import { createFileRoute } from "@tanstack/react-router";
import { PageContainer } from "../../../../components/core/basic/PageContainer";
import HarvestingRules from "../../../../modules/advertising/components/HavestingRules";
import { DatesProvider } from "../../../../dates/DatesContext";

const HarvestingRulesView = () => {
  return (
    <DatesProvider>
      <PageContainer>
        <HarvestingRules />
      </PageContainer>
    </DatesProvider>
  );
};

export const Route = createFileRoute("/_authenticated/user/advertising/harvesters")({
  component: HarvestingRulesView,
  staticData: { application: "Advertising" },
});
